/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";

import type {
  ErrorResponse,
  PlaylistCreateRequest,
  PlaylistUploadToYoutubeRequest,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 이미 업로드된 YouTube 영상의 메타데이터를 DB 값으로 업데이트합니다.
 * @summary YouTube 메타데이터 업데이트
 */
export const playlistUpdateYoutubeMetadata = (
  id: string,
  playlistCreateRequest: BodyType<PlaylistCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/${id}/update-youtube-metadata/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: playlistCreateRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistUpdateYoutubeMetadataMutationOptions = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistUpdateYoutubeMetadata>>,
    TError,
    { id: string; data: BodyType<PlaylistCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistUpdateYoutubeMetadata>>,
  TError,
  { id: string; data: BodyType<PlaylistCreateRequest> },
  TContext
> => {
  const mutationKey = ["playlistUpdateYoutubeMetadata"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistUpdateYoutubeMetadata>>,
    { id: string; data: BodyType<PlaylistCreateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return playlistUpdateYoutubeMetadata(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistUpdateYoutubeMetadataMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistUpdateYoutubeMetadata>>
>;
export type PlaylistUpdateYoutubeMetadataMutationBody =
  BodyType<PlaylistCreateRequest>;
export type PlaylistUpdateYoutubeMetadataMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary YouTube 메타데이터 업데이트
 */
export const usePlaylistUpdateYoutubeMetadata = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistUpdateYoutubeMetadata>>,
      TError,
      { id: string; data: BodyType<PlaylistCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistUpdateYoutubeMetadata>>,
  TError,
  { id: string; data: BodyType<PlaylistCreateRequest> },
  TContext
> => {
  const mutationOptions =
    getPlaylistUpdateYoutubeMetadataMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 
        플레이리스트의 컴파일된 비디오를 연동된 채널의 YouTube에 업로드합니다.
        
 * @summary YouTube 업로드
 */
export const playlistUploadToYoutube = (
  id: string,
  playlistUploadToYoutubeRequest: BodyType<PlaylistUploadToYoutubeRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/${id}/upload-to-youtube/`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: playlistUploadToYoutubeRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistUploadToYoutubeMutationOptions = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistUploadToYoutube>>,
    TError,
    { id: string; data: BodyType<PlaylistUploadToYoutubeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistUploadToYoutube>>,
  TError,
  { id: string; data: BodyType<PlaylistUploadToYoutubeRequest> },
  TContext
> => {
  const mutationKey = ["playlistUploadToYoutube"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistUploadToYoutube>>,
    { id: string; data: BodyType<PlaylistUploadToYoutubeRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return playlistUploadToYoutube(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistUploadToYoutubeMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistUploadToYoutube>>
>;
export type PlaylistUploadToYoutubeMutationBody =
  BodyType<PlaylistUploadToYoutubeRequest>;
export type PlaylistUploadToYoutubeMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary YouTube 업로드
 */
export const usePlaylistUploadToYoutube = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistUploadToYoutube>>,
      TError,
      { id: string; data: BodyType<PlaylistUploadToYoutubeRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistUploadToYoutube>>,
  TError,
  { id: string; data: BodyType<PlaylistUploadToYoutubeRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistUploadToYoutubeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
